import filterEFSHealth from './filterEFSHealth.json';
import filterEFSOperatingState from './filterEFSOperatingState.json';
import filterEFSRegion from './filterEFSRegion.json';
import filterEFSThroughput from './filterEFSThroughput.json';
import summaryEFSHealth from './summaryEFSHealth.json';
import summaryEFSOperatingState from './summaryEFSOperatingState.json';
import summaryEFSRegion from './summaryEFSRegion.json';
import summaryEFSThroughputMode from './summaryEFSThroughputMode.json';
import performanceOverview from './performance/efsPerformanceOverview.json';
import performanceMasterview from './performance/efsPerformanceMaster.json';
import performanceDetail from './performance/efsPerformanceDetail.json';
import performanceDetailTitle from './performance/efsPerformanceDetailTitle.json';
import metricIoUtilization from './performance/efsIOUtilization.json';
import metricFileSystemUsed from './performance/efsFileSysUsed.json';
import metricPermittedThroughput from './performance/efsPermittedThroughput.json';
import connectionsOverview from './connections/efsConnectionsOverview.json';
import connectionsMasterview from './connections/efsConnectionsMaster.json';
import connectionsDetailview from './connections/efsConnectionsDetail.json';
import connectionsDetailTitle from './connections/efsConnectionsDetailTitle.json';
import metricConnectedClients from './connections/efsConnectedClients.json';
import metricBurstCreditBalance from './connections/efsBurstCreditBalance.json';

export default [
  connectionsDetailview,
  connectionsDetailTitle,
  connectionsOverview,
  connectionsMasterview,
  filterEFSHealth,
  filterEFSOperatingState,
  filterEFSRegion,
  filterEFSThroughput,
  metricBurstCreditBalance,
  metricConnectedClients,
  metricIoUtilization,
  metricFileSystemUsed,
  metricPermittedThroughput,
  performanceDetail,
  performanceDetailTitle,
  performanceMasterview,
  performanceOverview,
  summaryEFSHealth,
  summaryEFSOperatingState,
  summaryEFSRegion,
  summaryEFSThroughputMode,
];
